export const AVAILABLE_LANGUAGES = [
    'cs',
    'en',
]

export const DEFAULT_LANGUAGE_CODE = 'cs'

export const DEVICE_IOS = 'ios'
export const DEVICE_ANDROID = 'android'
